<template>
  <div class="women-signup-layout text-women-text">
    <div class="bg-neutral-00 py-5 flex justify-center border-b border-neutral-200 mb-10">
      <client-only>
        <NuxtLink
          :to="{ path: $i18n.localePath('index') }"
        >
          <OSvg class="w-40 lg:w-48" svg="logo" />
        </NuxtLink>
      </client-only>
    </div>
    <ProgressSteps
      v-if="showProgressSteps"
      class="mb-10"
      :steps="steps"
      :disable-links="disableLinks"
      :active-index="activeStepIndex"
    />
    <nuxt />
  </div>
</template>

<script>
import OSvg from '@/components/OSvg'
import metaMixin from '@/mixins/meta'
import ProgressSteps from '@/components/Women/Signup/ProgressSteps'
import { mapState } from 'vuex'

export default {
  name: 'SignUpWomenLayout',
  components: { OSvg, ProgressSteps },
  mixins: [metaMixin],
  computed: {
    steps () {
      return [
        {
          link: this.$i18n.localePath({ name: 'women-signup' }),
          text: this.$t('SignUp.Women.Steps.Size')
        },
        {
          link: this.$i18n.localePath({ name: 'women-signup-free-gift' }),
          text: this.$t('SignUp.Women.Steps.FreeSet')
        },
        {
          link: this.$i18n.localePath({ name: 'women-signup-create-account' }),
          text: this.$t('SignUp.Women.Steps.Account')
        },
        {
          link: this.$i18n.localePath({ name: 'women-signup-create-account-address' }),
          text: this.$t('SignUp.Women.Steps.Shipping')
        },
        {
          link: this.$i18n.localePath({ name: 'women-signup-create-account-verification-payment' }),
          text: this.$t('SignUp.Women.Steps.Confirmation')
        }
      ]
    },
    disableLinks () {
      return this.isUser
    },
    activeStepIndex () {
      if (this.$route.name === 'lang-women-signup-free-gift') {
        return 2
      }

      if (this.$route.name === 'lang-women-signup-create-account') {
        return 3
      }

      if (this.$route.name === 'lang-women-signup-create-account-address') {
        return 4
      }

      if (
        this.$route.name === 'lang-women-signup-create-account-verification-payment' ||
        this.$route.name === 'lang-women-signup-create-account-verification-payment-success' ||
        this.$route.name === 'lang-women-signup-create-account-verification-payment-failed' ||
        this.$route.name === 'lang-women-signup-create-account-verification-payment-pending'
      ) {
        return 5
      }

      return 1
    },
    showProgressSteps () {
      if (
        this.$route.name === 'lang-women-signup-create-account-verification-payment-success' ||
        this.$route.name === 'lang-women-signup-create-account-verification-payment-failed' ||
        this.$route.name === 'lang-women-signup-create-account-verification-payment-pending'
      ) {
        return false
      }

      return true
    },
    ...mapState('womenSignup', {
      isUser: state => state.form.isUser
    })
  },
  head () {
    return {
      title: this.metaTitle
    }
  }
}
</script>

<style lang="postcss" scoped>
.women-signup-scrollable-container {
  @apply relative h-full overflow-y-auto;
  min-height: calc(100vh - 10rem);
}

>>> p.max-w-60rem,
>>> div.max-w-60rem {
  @apply mx-auto;
  max-width: 60rem;
}

>>> div.max-w-70rem {
  @apply mx-auto;
  max-width: 70.2rem;
}

@screen sm {
  >>> div.max-w-330 {
    @apply mx-auto;
    max-width: 33rem;
  }
}

@media (max-width: 1023px) {
  .page-slide-left-enter-active, .page-slide-left-leave-active {
    @apply transition-all absolute duration-700 max-w-full;
  }

  .page-slide-left-enter {
    right: -100%;
  }

  .page-slide-left-enter-to {
    right: 0;
  }

  .page-slide-left-leave {
    left: 0;
  }

  .page-slide-left-leave-to {
    left: -100%;
  }

  .page-slide-right-enter-active, .page-slide-right-leave-active {
    @apply transition-all absolute duration-700 max-w-full;
  }

  .page-slide-right-enter {
    left: -100%;
  }

  .page-slide-right-enter-to {
    left: 0;
  }

  .page-slide-right-leave {
    right: 0;
  }

  .page-slide-right-leave-to {
    right: -100%;
  }
}

.fade-in-enter,
.fade-in-leave {
  @apply opacity-0;
}

.fade-in-enter-active,
.fade-in-leave-active {
  @apply transition-opacity duration-300 ease-out;
}
</style>
